export default __webpack_public_path__ + "static/media/2021.f81e5fba.png";